export const GET_EXCEPTION_TABS_LIST = 'GET_EXCEPTION_TABS_LIST';
export const ADD_EXCEPTION_TAB = 'ADD_EXCEPTION_TAB';
export const UPDATE_EXCEPTION_TAB_LIST = 'UPDATE_EXCEPTION_TAB_LIST';
export const REMOVE_EXCEPTION_TAB = 'REMOVE_EXCEPTION_TAB';
export const CHANGE_ACTIVE_EXCEPTION_TAB = 'CHANGE_ACTIVE_EXCEPTION_TAB';

export const STORE_EXCEPTION_SEARCHED_DATA = 'STORE_EXCEPTION_SEARCHED_DATA';
export const STORE_EXCEPTION_SEARCHED_QUERY = 'STORE_EXCEPTION_SEARCHED_QUERY';
export const RESET_EXCEPTION_SEARCHED_DATA = 'RESET_EXCEPTION_SEARCHED_DATA';
